import styled from 'styled-components'

export const StyledLoading = styled.div`

`
